import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { AVERAGE_OPTIONS } from "../constants";

export const Averages = () => {
  const dispatch = useDispatch();

  const average = useSelector((state) => state.utilization.average);
  const futureBookingsToggle = useSelector((state) => state.utilization.future_bookings);

  if (average && !futureBookingsToggle) {
    return (
      <div className="select-box" style={{ width: "200px" }}>
        <p className="offers-title">Average</p>
        <MultiSelectDropdown
          options={AVERAGE_OPTIONS}
          selectedFilters={average}
          numberDisplayed={0}
          onSelectChange={(data) => dispatch(actionCreators.setAverage(data))}
        />
      </div>
    );
  }

  return null;
};
